import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "../../../style/slabreachmonitor.css";
import { apiAxios } from "../../../utils/apiAxios";

interface RowType {
  id: number;
  name: string;
  breached: number;
  status: string;
  orderId: string;
  date: string;
  time: string;
}

interface SlaSummary {
  id: number;
  name: string;
  totalSLABreach: number;
}

interface ModalRowType {
  orderId: string;
  date: string;
  time: string;
}

interface SlaDetails {
  caseID: number;
  orderID: string;
  breachTime: string;
}


const ManagerSLABreachMonitor = () => {
  const [activeTab, setActiveTab] = useState<"designer" | "milling">("designer");
  const [showModal, setShowModal] = useState(false);



  const getColumns = (label: string) => [
    {
      name: `${label} Name`,
      selector: (row: RowType) => row.name,
      sortable: true,
    },
    {
      name: "Total Breach",
      selector: (row: RowType) => row.breached,
    },
    {
      name: "Status",
      cell: (row: RowType) =>
        row.status === "red" ? (
          <span className="badge bg-danger">Red Flag</span>
        ) : (
          <span className="badge bg-success">OK</span>
        ),
    },
  ];

  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const modalColumns = [
    { name: "Order ID", selector: (row: ModalRowType) => row.orderId },
    { name: "SLA Breached Date", selector: (row: ModalRowType) => row.date },
    { name: "SLA Breached Time", selector: (row: ModalRowType) => row.time },
  ];

  const [summary, setSummary] = useState<SlaSummary[]>([]);
  const [details, setDetails] = useState<SlaDetails[]>([]);


  const fetchSummary = async () => {
    try {
      const url =
        activeTab === "designer"
          ? `${API_BASE}/Manager/designer-summary`
          : `${API_BASE}/Manager/milling-summary`;

      const res = await apiAxios.get(url);
      if (res.data.isSuccess) {
        setSummary(res.data.data || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // ✅ Fetch Details
  const fetchDetails = async (id: number) => {
    try {
      const url =
        activeTab === "designer"
          ? `${API_BASE}/Manager/designer-details/${id}`
          : `${API_BASE}/Manager/milling-details/${id}`;


      const res = await apiAxios.get(url);
      if (res.data.isSuccess) {
        setDetails(res.data.data || []);
        setShowModal(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, [activeTab]);


  const totalBreach = summary.reduce(
    (sum, item) => sum + item.totalSLABreach,
    0
  );

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  return (
    <div className="container mt-4">
      <h4 className="mb-4">SLA Breach Monitor</h4>

      {/* Tabs */}
      <div className="d-flex justify-content-center mb-4 gap-3">
        <div
          className={`tab-btn ${activeTab === "designer" ? "active" : ""}`}
          onClick={() => setActiveTab("designer")}
        >
          Designer SLA Breach Monitor
        </div>

        <div
          className={`tab-btn ${activeTab === "milling" ? "active" : ""}`}
          onClick={() => setActiveTab("milling")}
        >
          Milling SLA Breach Monitor
        </div>
      </div>

      {/* SLA Card (Clickable) */}
      <div className="row mb-4">
        <div className="col-md-12 col-12 col-lg-3">
          <div
            className="order-status-barsla"
            onClick={() => fetchDetails(0)}
            style={{ cursor: "pointer" }}
          >
            <div className="status-col">
              <h3>{totalBreach}</h3>
              <div className="status-badge total-sla-breach">
                {activeTab === "designer"
                  ? "Designer SLA Breach"
                  : "Milling SLA Breach"}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="premium-card">
        {activeTab === "designer" && (
          <DataTable
            columns={getColumns("Designer")}
            // data={designerData}
            data={summary.map(item => ({
              id: item.id,
              name: item.name,
              breached: item.totalSLABreach,
              status: item.totalSLABreach > 0 ? "red" : "ok",
              orderId: "",
              date: "",
              time: ""
            }))}
            pagination
            onRowClicked={(row) => fetchDetails(row.id)}
          />
        )}

        {activeTab === "milling" && (
          <DataTable
            columns={getColumns("Milling")}
            // data={millingData}
            data={summary.map(item => ({
              id: item.id,
              name: item.name,
              breached: item.totalSLABreach,
              status: item.totalSLABreach > 0 ? "red" : "ok",
              orderId: "",
              date: "",
              time: ""
            }))}
            pagination
            onRowClicked={(row) => fetchDetails(row.id)}
          />
        )}
      </div>

      {showModal && (
        <>
          <div className="modal show d-block">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title">SLA Breached Orders</h5>
                  <button type="button" onClick={() => setShowModal(false)} className="btn-close custom-close-btn" data-bs-dismiss="modal" aria-label="Close"><i className="bi bi-x customcross"></i></button>

                </div>

                <div className="modal-body">
                  <DataTable
                    columns={modalColumns}
                    // data={breachedData}  
                    data={details.map(d => ({
                      orderId: d.orderID,
                      date: formatDate(d.breachTime),
                      time: new Date(d.breachTime).toLocaleTimeString("en-GB"),
                    }))}
                    pagination
                    highlightOnHover
                    striped
                  />
                </div>

              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default ManagerSLABreachMonitor;